import { MultiString } from '../../../common/index';

export class HelpArticle {
    title: MultiString;
    content: MultiString;
}
